/**
 * Returns the source path for a package based on the repo link, group, and directory name.
 * This implementation is a bit fragile but has been modularized for testing.
 */

const getPackageSourceLink = (
  repository: string,
  group: string,
  directoryName: string,
): string => {
  if (group && directoryName && repository.includes('bitbucket.org')) {
    if (repository.includes('atlassian-frontend-mirror')) {
      return `${repository}/src/master/${group}/${directoryName}`;
    }
    if (repository.includes('atlassian-frontend')) {
      return `${repository}/src/master/packages/${group}/${directoryName}`;
    }
  }
  return repository || '';
};

export default getPackageSourceLink;
